import React, { useState, useEffect } from 'react';
import { servicesAPI } from '../services/api';

export default function ServicesManagement() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState({ name: '', nameEn: '', description: '', price: '', duration: '', category: 'exterior' });

  useEffect(() => { loadServices(); }, []);

  const loadServices = async () => {
    try {
      const { data } = await servicesAPI.getAll();
      setServices(data.services);
    } catch (error) {
      console.log('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await servicesAPI.update(editId, form);
      } else {
        await servicesAPI.create(form);
      }
      setShowForm(false);
      setEditId(null);
      setForm({ name: '', nameEn: '', description: '', price: '', duration: '', category: 'exterior' });
      loadServices();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const handleEdit = (service) => {
    setForm({
      name: service.name, nameEn: service.nameEn || '',
      description: service.description || '', price: service.price,
      duration: service.duration, category: service.category,
    });
    setEditId(service._id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل تريد حذف هذه الخدمة؟')) return;
    try {
      await servicesAPI.delete(id);
      loadServices();
    } catch (error) {
      console.log('Error:', error);
    }
  };

  const categories = {
    exterior: 'غسيل خارجي', interior: 'غسيل داخلي', full: 'غسيل شامل',
    polish: 'تلميع', engine: 'غسيل محرك', subscription: 'اشتراك',
  };

  if (loading) return <div className="loading">جاري التحميل...</div>;

  return (
    <div>
      <div className="page-header">
        <h2>إدارة الخدمات</h2>
        <button className="btn btn-primary" onClick={() => { setShowForm(true); setEditId(null); setForm({ name: '', nameEn: '', description: '', price: '', duration: '', category: 'exterior' }); }}>
          + إضافة خدمة
        </button>
      </div>

      {showForm && (
        <div className="card form-card">
          <h3>{editId ? 'تعديل الخدمة' : 'إضافة خدمة جديدة'}</h3>
          <form onSubmit={handleSubmit} className="service-form">
            <div className="form-row">
              <div className="form-group">
                <label>اسم الخدمة (عربي)</label>
                <input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>اسم الخدمة (إنجليزي)</label>
                <input value={form.nameEn} onChange={(e) => setForm({...form, nameEn: e.target.value})} />
              </div>
            </div>
            <div className="form-group">
              <label>الوصف</label>
              <textarea value={form.description} onChange={(e) => setForm({...form, description: e.target.value})} />
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>السعر (ج.م)</label>
                <input type="number" value={form.price} onChange={(e) => setForm({...form, price: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>المدة (دقيقة)</label>
                <input type="number" value={form.duration} onChange={(e) => setForm({...form, duration: e.target.value})} required />
              </div>
              <div className="form-group">
                <label>الفئة</label>
                <select value={form.category} onChange={(e) => setForm({...form, category: e.target.value})}>
                  {Object.entries(categories).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
            </div>
            <div className="form-actions">
              <button type="submit" className="btn btn-primary">{editId ? 'حفظ التعديل' : 'إضافة'}</button>
              <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>إلغاء</button>
            </div>
          </form>
        </div>
      )}

      <div className="services-grid">
        {services.map((service) => (
          <div key={service._id} className="service-card">
            <div className="service-card-header">
              <span className="service-icon">{service.icon || '🧽'}</span>
              <span className={`badge ${service.category}`}>{categories[service.category]}</span>
            </div>
            <h3>{service.name}</h3>
            <p className="service-desc">{service.description}</p>
            <div className="service-meta">
              <span>💰 {service.price} ج.م</span>
              <span>⏱️ {service.duration} دقيقة</span>
            </div>
            <div className="service-actions">
              <button className="btn btn-sm btn-primary" onClick={() => handleEdit(service)}>تعديل</button>
              <button className="btn btn-sm btn-danger" onClick={() => handleDelete(service._id)}>حذف</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
